import { useMutation } from "@tanstack/react-query";
import { generateOTP } from "app/api/otp_api";

export const useGenerateOTP = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (params) =>
      generateOTP({ email: params.email, type: params.type, name: params.name }),
    onSuccess: onSuccess,
    onError: (error) => onError(error)
  });
};
